import React from 'react';


class circle extends React.Component {
    constructor(...props) {
        super(...props);
        this.state = {
            circleBottomColor:"#f2f2f2",//圆环底色
            innerColorStart:'#ffdd00',  //内部圆环 渐变色开始
            innerColorEnd:'#fc7d37', //内部圆环 渐变色结束
            lineW: 20
        };
        
    }
    
    componentWillReceiveProps(nextProps) {
        // console.log(nextProps)
        if(nextProps.percent != this.props.percent){
            this.updata(nextProps.percent);
        }
    }

    componentDidMount() {
        this.canvasC = document.getElementById(this.props.id);
        this.context = this.canvasC.getContext('2d');
        this.option={
            circleBottomColor: this.props.circleBottomColor ? this.props.circleBottomColor : this.state.circleBottomColor,
            innerColorStart: this.props.innerColorStart ? this.props.innerColorStart : this.state.innerColorStart,
            innerColorEnd: this.props.innerColorEnd ? this.props.innerColorEnd : this.state.innerColorEnd,
            lineW: this.props.lineW ? this.props.lineW : this.state.lineW,
        };
        this.preA=Math.PI/180;
        this.width = this.canvasC.width;
        this.height = this.canvasC.height;
        this.R1=parseInt(this.canvasC.width/2-this.option.lineW);

        this.canvasC.style.width = this.width/2 + "px";
        this.canvasC.style.height = this.height/2 + "px";
        this.canvasC.height = this.height;
        this.canvasC.width = this.width;
        
        this.init(this.props.percent);
    }

    init(percent){
        // console.log(window.devicePixelRatio)
        var rotateAngle = percent*360;
        this.rotataRadians = this.preA*rotateAngle;
        this.x=this.canvasC.width/2;
        this.y=this.canvasC.height/2;
        this.startAa=-Math.PI/2;
        this.startA=0;
        this.Timer;
        this.drawing(1);
        this.Timer=setInterval(()=>{
            this.drawing(2);
        },20);
    }

    drawing(type){
        if(this.startA < this.rotataRadians){
            this.startA+=0.1;
        }
        this.context.save();
        this.context.setTransform(1,0,0,1,0,0);
        this.context.fillStyle="rgba(255, 255, 255, 0)";
        this.context.fillRect(0,0,this.canvasC.width,this.canvasC.height);
        this.context.translate(this.x,this.y);
        this.context.rotate(-Math.PI/2);

        if(type === 1){
            //底环
            this.context.beginPath();
            this.context.strokeStyle=this.option.circleBottomColor;
            this.context.lineWidth = this.option.lineW;
            this.context.translate(0.5, 0.5);
            this.context.arc(0,0,this.R1,0,Math.PI*2,false);
            this.context.stroke();
            this.context.closePath();
        }

        this.context.beginPath();
        var gradient2 = this.context.createLinearGradient(this.R1, 0,-this.R1,0);
        gradient2.addColorStop(0, this.option.innerColorStart);
        gradient2.addColorStop(1, this.option.innerColorEnd);
        this.context.lineCap="round";
        this.context.strokeStyle=gradient2;
        this.context.lineWidth = this.option.lineW;
        this.context.translate(0.5, 0.5);
        this.context.arc(0,0,this.R1,0,this.startA,false);
        this.context.stroke();
        this.context.closePath();
    
        //画图
        if(this.startAa < this.rotataRadians-Math.PI/2){
            this.startAa+=0.1;
        }else{
            clearInterval(this.Timer);
        }
    }
    
    updata(percent){
        clearInterval(this.Timer);
        this.init(percent);
    }
    
    render() {
        return (
            <canvas id={this.props.id} width={this.props.width} height={this.props.height} ></canvas>
        );
    }
}

export default circle;


// WEBPACK FOOTER //
// ./src/dataScreen/modules/circle/index.js